<template>
  <div style="height: 100%;width:100%">
    <!--核算目前有2,3,5,6-->
    <!-- {{isShow}} {{isShowMock}} {{isShowHy}} {{isShowPractice}} -->
    <cost-acc v-if="isShow" :planclassesId="planclassesId" :data="data"
              :classesId="classesId" :title="title" :item="item"></cost-acc>
    <mock :data="data" v-if="isShowMock" :classesProp="classesProp"
          :planclassesId="planclassesId" :classesId="classesId" :title="title"></mock>
    <!-- <hy-acc v-if="isShowHy" :planclassesId="planclassesId" :classesId="classesId"
            :classesProp="classesProp"></hy-acc> -->
    <apoit-hy-acc v-if="isShowHy" :data="data" :planclassesId="planclassesId" :classesId="classesId"
                  :classesProp="classesProp"></apoit-hy-acc>
    <!-- 会计代账实习基地-->
    <agent-practice v-if="isShowPractice" :planclassesId="planclassesId" :data="data"
                    style="width: 100%;height: 100%;" :classesId="classesId" :classesProp="classesProp">
    </agent-practice>
    <madp v-if="isShowSP" :planclassesId="planclassesId" :data="data"
                    style="width: 100%;height: 100%;" :classesId="classesId" :classesProp="classesProp">
    </madp>
  </div>
</template>

<script>

// import Vue from 'vue'
import costAcc from '../cost-acc/index.vue'
import mock from '../mock/index.vue'
import hyAcc from './hy-acc/index'
import apoitHyAcc from './APOIT-hy-acc/index.vue'
import agentPractice from './agent-practice/index.vue'
import madp from '../mock/madpsp/index.vue'
import { checkIsAccCost, checkIsMock, checkIsAPOITHY, checkIsAGENT, checkIsSHAPAN } from './hock'
import { AddDetail } from '@/api/myClass'

// import { getExamSubjects } from '../mock/api'

export default {
  name: 'Addition',
  components: {
      // classesConst,
      costAcc,
      mock,
      hyAcc,
      apoitHyAcc,
      agentPractice,
      madp
  },
  data() {
    return {
        item: true,
        planclassesId: '',
        classesId: '',
        title: '',
        classesProp: '',
        // isShow: false,
        planclassCouseTypes: '',
        // isShowMock: '',
        data: {
          classesProp: ''
        }
    }
  },
  computed: {
    isShow() {
      return checkIsAccCost(this.data.classesProp)
    },
    isShowMock() {
      return checkIsMock(this.data.classesProp)
    },
    isShowHy() {
      return checkIsAPOITHY(this.data.classesProp)
    },
    isShowPractice() {
      return checkIsAGENT(this.data.classesProp)
    },
    isShowSP() {
      return checkIsSHAPAN(this.data.classesProp)
    },
  },
  created() {
    if (this.$route.query.planclassesId) {
      this.planclassesId = this.$route.query.planclassesId
      this.classesId = this.$route.query.classesId
    }
      const param = {
          planclassesId: this.planclassesId,
          classesId: this.classesId,
      }
      AddDetail(param).then(res => {
          console.log(res)
          this.data = res
          this.data.courseType = this.data.mockType
          console.log(this.data)
          this.data.classesProp = Number(this.data.classesProp)
          console.log(this.isShowMock)
      })
      // getExamSubjects().then(res => {
      //     console.log(res)
      //     this.data = res
      //     // this.data.courseType = Vue.ls.get('classesType')
      //     console.log(this.data)
      // })
  },
  methods: {
  },
}
</script>
<style scoped lang="less">

</style>
